export default __webpack_public_path__ + "static/media/img18.294bf082.png";